<template>
  <div>
    <Popover
      ref="filterPopover"
      :showHeader="true"
      :appendToBody="appendToBody"
      :headerTitle="headerTitle"
      :placement="placement"
      :sizeClass="sizeClass"
    >
      <div class="filter-content grid-force-newlines">
        <slot name="popover" />

      </div>
      <div v-if="showApplyButton || showResetButton" class="filter-content-footer row">
        <div class="col-4">
          <FormButton class="btn-block btn-primary btn-med" v-if="showApplyButton" @click="applyFilters"><i class="far fa-check-circle"></i> Apply</FormButton>
        </div>
        <div class="col-4"> </div>
        <div class="col-4 text-right">
          <FormButton class="btn-block btn-warning btn-med" v-if="showResetButton" @click="resetFilters"><i class="far fa-times"></i> Reset</FormButton>
        </div>
      </div>
    </Popover>
    <div class="input-group">
      <div class="filter-display-area filter-right-aligned" v-if="isRightAlignment">
        <slot name="filterDisplay" />
      </div>
      <div :class="['input-group-prepend', 'dt-filter-item', filterActive ? 'text-info' : '']" @click="displayFilterPopover">
        <span class="input-group-addon"><i :class="[filterActive ? 'fas' : 'far', 'fa-filter']"></i></span>
      </div>
      <div class="filter-display-area filter-left-aligned" v-if="isLeftAlignment">
        <slot name="filterDisplay" />
      </div>
    </div>
  </div>
</template>

<style>
.filter-content {
  padding: 8px;
  font-size: 0.75rem;
  line-height: 1rem;
}
.filter-display-area {
  border: none;
  padding: 4px 0px 4px 0px;
}
.filter-display-area.filter-right-aligned {
  padding-right: 12px;
}
.filter-display-area.filter-left-aligned {
  padding-left: 12px;
  margin-left: 1px;
}
.filter-display-area > div {
  display: inline-block;
  border-radius: 5px;
  background-color: #e5e6e7;
  border: 1px solid #d9dadb;
  font-size: 0.75rem;
  padding: 2px 6px 2px 6px;
  margin: 0 4px 0 0;
}
.filter-content-footer {
  border-top: 1px dashed #efefef;
  padding: 8px 8px 0px 8px;
}



</style>

<script>
import Popover from '@/components/popover.vue'

export default {
  name: 'ReportFilterPopover',
  components: {
    Popover
  },
  props: {
    placement: {
      type: String,
      default: 'bottom'
    },
    alignment: {
      type: String,
      default: 'right'
    },
    sizeClass: {
      type: String,
      default: 'popover-xlarge'
    },
    headerTitle: {
      type: String,
      default: 'Filter'
    },
    filterActive: {
      type: Boolean,
      default: false
    },
    showApplyButton: {
      type: Boolean,
      default: false
    },
    showResetButton: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isRightAlignment() {
      return this.alignment == 'right'
    },
    isLeftAlignment() {
      return this.alignment == 'left'
    },
  },
  methods: {
    displayFilterPopover(evt) {
      this.$refs.filterPopover.displayFromElement(evt.target)
    },
    hidePopover() {
      this.$refs.filterPopover.hidePopover()
    },
    applyFilters(ev) {
      this.$emit('apply', ev)
      this.$refs.filterPopover.hidePopover()
    },
    resetFilters(ev) {
      this.$emit('reset', ev)
      this.$refs.filterPopover.hidePopover()
    }
  }
}
</script>